import { useMutation } from "@tanstack/react-query";
import { sendFeedback } from "../services/feedback-service";
import { FeedbackParams, FeedbackResponse } from "../types/feedback";

export const useSendFeedback = () => {
  return useMutation<FeedbackResponse, Error, FeedbackParams>({
    mutationFn: async (params: FeedbackParams) => {
      return await sendFeedback(params);
    },
    onError: (error) => {
      console.error("Error sending feedback:", error);
    },
  });
};
